import React, { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Popover,
  Typography,
} from '@mui/material'
import { useNotificationsCalls } from '../../hooks'
import { styled } from '@mui/material'
import { PopupDialogComponent } from '../../dialogs'
import { useIntl } from 'react-intl'
import { NoticesPopupComponent } from '../notices-popup'
import AnnouncementIcon from '@mui/icons-material/Announcement'

const useStyles = styled(() => ({
  root: {
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      ellipsis: true,
      textAlign: 'justify',
    },
  },
}))
export const NoticesHistoryComponent = ({ className }) => {
  const intl = useIntl()
  const { formatMessage } = intl
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const { getAvisosByUser, markAsRead } = useNotificationsCalls()
  const [notifications, setNotifications] = useState(null)
  const [nottificationsNotRead, setNottificationsNotRead] = useState(0)

  const [selectedAviso, setSelectedAviso] = useState({})
  const [openDialog, setOpenDialog] = useState(false)

  useEffect(() => {
    getAvisosByUser({ params: { full: true } }).then((response) => {
      setNotifications(response.data)
      setNottificationsNotRead(getNotReadNotifications(response.data))
    })
  }, [])

  useEffect(() => {
    setNottificationsNotRead(getNotReadNotifications(notifications))
  }, [notifications])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  function closeDialog() {
    setOpenDialog(false)
    setSelectedAviso({})
  }

  function readAviso() {
    markAsRead(selectedAviso.id).then(() => {
      let newAvisos = [...notifications]
      for (let i = 0; i < newAvisos.length; i++) {
        if (newAvisos[i].id === selectedAviso.id) {
          newAvisos[i].ignore = true
        }
      }
      setNotifications(newAvisos)
      closeDialog()
    })
  }

  const showDetail = (index) => () => {
    setAnchorEl(null)
    let aviso = {
      id: notifications[index].id,
      title: notifications[index].title,
      text: notifications[index].body,
      links: notifications[index].links,
      ignore: notifications[index].ignore,
    }
    setSelectedAviso(aviso)
    setOpenDialog(true)
  }

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    const dateObj = new Date(date)
    return dateObj.toLocaleDateString('es-ES', options)
  }

  const getNotReadNotifications = (not) => {
    if (!not) return 0
    const notRead = not.filter((notification) => !notification.ignore).length
    return notRead
  }

  const open = Boolean(anchorEl)

  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      {nottificationsNotRead > 0 ? (
        <IconButton
          className={className}
          aria-describedby={id}
          onClick={handleClick}
          style={{ color: 'black' }}
          aria-label="Notificaciones"
        >
          <Badge badgeContent={nottificationsNotRead} color="secondary">
            <AnnouncementIcon />
          </Badge>
        </IconButton>
      ) : (
        <IconButton
          className={className}
          aria-describedby={id}
          onClick={handleClick}
          style={{ color: 'black' }}
          aria-label="Notificaciones"
        >
          <AnnouncementIcon />
        </IconButton>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div style={{ width: '20rem', padding: 5, height: '80%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: 20,
              paddingBottom: 0,
              marginBottom: 20,
            }}
          >
            <Typography variant="h6" gutterBottom color="primary">
              <i>{formatMessage({ id: 'pages.notices.history.title' })}</i>
            </Typography>
          </div>
          {notifications &&
            notifications.map((notification, index) => (
              <Card
                key={index}
                variant="outlined"
                sx={{
                  width: '100%',
                  marginBottom: '10px',
                  background: '#f3f3f3',
                  position: 'relative',
                  border: !notification.ignore
                    ? '2px solid #f6bf00'
                    : '1px solid rgba(0, 0, 0, 0.12)',
                }}
              >
                {!notification.ignore ? (
                  <Badge color="secondary" badgeContent=" " style={{ width: '100%' }}>
                    <CardContent style={{ paddingBottom: 0 }}>
                      <Typography variant="h6" component="div">
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          display: '-webkit-box',
                          '-webkit-line-clamp': 3,
                          '-webkit-box-orient': 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        dangerouslySetInnerHTML={{ __html: notification.body }}
                      ></Typography>
                    </CardContent>
                  </Badge>
                ) : (
                  <CardContent style={{ paddingBottom: 0 }}>
                    <Typography variant="h6" component="div">
                      {notification.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      component="div"
                      className={classes.bodyText}
                      dangerouslySetInnerHTML={{ __html: notification.body }}
                    ></Typography>
                  </CardContent>
                )}
                <CardActions>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Button size="small" color="primary" onClick={showDetail(index)}>
                      Ver detalles
                    </Button>
                    <Typography variant="caption" component="div">
                      {formatDate(notification.start_date)}
                    </Typography>
                  </div>
                </CardActions>
              </Card>
            ))}
          {notifications && notifications.length === 0 && (
            <Typography variant="body" component="div" style={{ padding: '0 20px 20px 20px' }}>
              <i>{formatMessage({ id: 'pages.notices.history.empty' })}</i>
            </Typography>
          )}
        </div>
      </Popover>
      {selectedAviso.title && (
        <PopupDialogComponent
          open={openDialog}
          onClose={closeDialog}
          onRead={readAviso}
          {...selectedAviso}
        />
      )}
      <NoticesPopupComponent avisos={notifications} setAvisos={setNotifications} />
    </div>
  )
}
